export default "__VITE_ASSET__B6ys6y8j__ 584w";